module.exports = __webpack_public_path__ + "img/feature-nutrition.9ec9069a.jpg";